import "./index.scoped.css"

function AppContainer(props) {
    return (
        <div className="container">
            {props.children}
        </div >
    );
}

export default AppContainer;